export enum UploadDataType {
    IRRIGATION_RAINFALL = "irrigation_rainfall",
    CSV_UPLOAD = "csv_upload",
}

export enum UploadDataView {
    OPTIONS,
    IRRIGATION_RAINFALL,
    CSV_UPLOAD,
}

export interface Item {
    id: string | null;
    rainfall: {
        value: number | null;
        changed: boolean;
    };
    irrigation: {
        value: number | null;
        changed: boolean;
    };
    error: boolean;
    reprocessNotif?: boolean;
    date: string | undefined;
}
